import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ControllerMessages } from 'src/intl/ControllerMessages';
import { GenericMessages } from 'src/intl/GenericMessages';
import { AppModal } from '../reusable-components/app-modal/AppModal';
import { Input } from '../reusable-components/Input';

interface UpdateControllerModalProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
  /**
   * Triggers the request to close the modal and submit the edit-profile.
   */
  onSave: (description: string | undefined | null) => void;
  /**
   * The description of the controller
   */
  controllerDescription: string;
}

const UpdateControllerModal: React.FC<UpdateControllerModalProps> = ({
  onClose,
  isOpen,
  onSave,
  controllerDescription,
}) => {
  const { formatMessage } = useIntl();
  const [description, setDescription] = useState<string | undefined>(controllerDescription);

  useEffect(() => {
    setDescription(controllerDescription);
  }, [controllerDescription, isOpen]);

  return (
    <AppModal
      isOpen={isOpen}
      onClose={onClose}
      title={formatMessage(ControllerMessages.updateDescription)}
      primaryButton={{
        label: formatMessage(GenericMessages.saveButtonLabel),
        onClick: () => onSave(description),
      }}
      secondaryButton={{
        label: formatMessage(GenericMessages.cancelButtonLabel),
        onClick: () => onClose(),
      }}
    >
      <Input
        value={description}
        label={formatMessage(ControllerMessages.descriptionLabel)}
        onChange={e => setDescription(e.detail.value)}
        id="update-controller-description"
      />
    </AppModal>
  );
};

export default UpdateControllerModal;
